export enum InCallActionsEnum {
    ADD_MINUTES = "add_minutes",
    BOOST_PLAN = "boost_plan",
    CONTACT_LISTING = "contact_listing",
    CALL = "call",
    MESSAGE = "message",
    VOICE_MESSAGE = "voice_message",
}